// Same imports
import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  Button,
  Table,
  Toast,
  ToastContainer,
  Modal,
} from "react-bootstrap";
import PulseLoader from "react-spinners/PulseLoader";
import Select from "react-select";
import "./Supplier-s2.css";
import {
  InsertInvoiceDocDetailsForOCR,
  updateinvoicedetails,
  getInvoiceDocumentDetails,
  uploadInvoiceDocOCR,
  uploadInvoiceDocOCRVizio,
  viewDoc,
  InsertOCRApiResponseLog,
  getCompanyMasterDropDown,
} from "../../services/OCRDataService";
import axios from "axios";
import { getUser } from "../../services/authService";
import { Row, Col } from "react-bootstrap";

function Supplier() {
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [toastMessage, setToastMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedFileType, setSelectedFileType] = useState("Commercial Invoice");
  const [previewFile, setPreviewFile] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  const fileInputRef = useRef(null);

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const response = await getCompanyMasterDropDown();
        setSupplierOptions(response.data);
      } catch (error) {
        console.error("Failed to fetch suppliers", error);
        showToast("danger", "Failed to load supplier names.");
      }
    };

    fetchSuppliers();
  }, []);

  const handleFileTypeChange = (e) => {
    setSelectedFileType(e.target.value);
  };

// helper to check if invoice already has both docs
const getInvoiceDocsFromDB = async (invoiceNo) => {
  try {
    const startDate = "2025-01-01"; // adjust as needed
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const endDate = tomorrow.toISOString().split("T")[0];

    const url = `https://vizioapi.quloi.com/AryabhattaDev/getInvoiceCargoDocumentsStatus?startDate=${startDate}&endDate=${endDate}`;
    const resp = await axios.get(url, {
      headers: { Authorization: `Bearer ${getUser().token}` },
    });

    const data = resp?.data;
    if (!Array.isArray(data)) return [];

    // filter for this invoice
    return data.filter(d => String(d.InvoiceNumber).trim() === invoiceNo.trim());
  } catch (err) {
    console.error("Error fetching invoice docs:", err);
    return [];
  }
};


const handleFileChange = async (event) => {
  const selectedFile = event.target.files?.[0];
  if (!selectedFile) return;

 
  if (!invoiceNumber?.trim() || !selectedSupplier) {
    showToast("danger", "Enter invoice number and select supplier first.");
    if (fileInputRef.current) fileInputRef.current.value = "";
    return;
  }


  if (selectedFile.type !== "application/pdf") {
    showToast("danger", "Only PDF files are allowed.");
    if (fileInputRef.current) fileInputRef.current.value = "";
    return;
  }


  const existingDocs = await getInvoiceDocsFromDB(invoiceNumber.trim());
  const existingDocTypes = existingDocs.map(d => d.Document_type.toLowerCase());

  // Enforce order: Commercial Invoice must be uploaded before Packing List
  if (selectedFileType === "Packing List") {
    const hasCIInDB = existingDocTypes.includes("commercial invoice");
    const hasCIInLocal = fileList.some(
      f => f.invoiceNumber === invoiceNumber.trim() && f.documentType === "Commercial Invoice"
    );

    if (!hasCIInDB && !hasCIInLocal) {
      showToast(
        "warning",
        `Upload Commercial Invoice first before uploading a Packing List for invoice ${invoiceNumber.trim()}.`
      );
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }
  }

 
  if (existingDocTypes.includes(selectedFileType.toLowerCase())) {
    showToast(
      "warning",
      `Invoice ${invoiceNumber.trim()} already has a ${selectedFileType} uploaded.`
    );
    if (fileInputRef.current) fileInputRef.current.value = "";
    return;
  }

  const alreadyExistsLocally = fileList.some(
    f => f.invoiceNumber === invoiceNumber.trim() && f.documentType === selectedFileType
  );
  if (alreadyExistsLocally) {
    showToast(
      "warning",
      `Already selected ${selectedFileType} for invoice ${invoiceNumber.trim()}.`
    );
    if (fileInputRef.current) fileInputRef.current.value = "";
    return;
  }

 
  const supplier = supplierOptions.find((s) => s.Id === parseInt(selectedSupplier));
  const supplierCode = supplier?.Code || "SUP";
  const invWithCode = `${invoiceNumber.trim()}_${supplierCode}`;
  const updatedFileName = `${selectedFile.name.replace(/\.pdf$/i, "")}_${supplierCode}_${invoiceNumber.trim()}.pdf`;

  
  setPreviewFile({
    rawFile: selectedFile,
    previewUrl: URL.createObjectURL(selectedFile),
    documentType: selectedFileType,
    supplierId: selectedSupplier,
    supplierCode,
    setName: invWithCode,
    updatedFileName,
    invoiceNumber: invoiceNumber.trim(),
  });
  setShowPreview(true);

  // reset file input
  if (fileInputRef.current) fileInputRef.current.value = "";
};
const confirmPreview = () => {
  if (!previewFile) return;

  // Check if file already exists in fileList
  const alreadyExists = fileList.some(
    (f) =>
      f.invoiceNumber === previewFile.invoiceNumber &&
      f.documentType === previewFile.documentType
  );

  if (alreadyExists) {
    showToast(
      "warning",
      `${previewFile.documentType} for invoice ${previewFile.invoiceNumber} is already selected.`
    );
    setPreviewFile(null);
    setShowPreview(false);
    return;
  }

  const newFile = {
    name: previewFile.updatedFileName || previewFile.name,
    date: new Date().toISOString().slice(0, 19).replace("T", " "),
    invoiceNumber: previewFile.invoiceNumber,
    file: new File([previewFile.rawFile], previewFile.updatedFileName, {
      type: previewFile.rawFile.type,
    }),
    documentType: previewFile.documentType,
    supplierId: previewFile.supplierId,
    supplierCode: previewFile.supplierCode,
    setName: previewFile.setName,
    previewUrl: URL.createObjectURL(previewFile.rawFile),
  };

  setFileList((prev) => [...prev, newFile]);
  setPreviewFile(null);
  setShowPreview(false);
};

const cancelPreview = () => {
  setPreviewFile(null);
  setShowPreview(false);
};


const handlePreview = (file) => {
  // generate preview URL
  const previewUrl = file.rawFile
    ? URL.createObjectURL(file.rawFile)
    : file.file
    ? URL.createObjectURL(file.file)
    : null;

  // check if file already exists in fileList
  const alreadyInList = fileList.some(
    (f) =>
      f.invoiceNumber === file.invoiceNumber &&
      f.documentType === file.documentType
  );

  setPreviewFile({
    ...file,
    previewUrl,
    rawFile: file.rawFile || file.file, // keep rawFile for confirm
    alreadyInList, // track duplicate
  });

  setShowPreview(true);
};



const handleUpload = async () => {
  if (!invoiceNumber.trim() || fileList.length === 0 || !selectedSupplier) {
    showToast("danger", "Provide invoice number, supplier, and select files.");
    return;
  }

  setLoading(true);

  try {
    // Step 1️⃣ Upload files to S3 & Vizio
    for (const fileObj of fileList) {
      const formDataS3 = new FormData();
      formDataS3.append("InvPackAggfiles", fileObj.file, fileObj.name.replace(/#/g, ""));

      const s3Response = await uploadInvoiceDocOCR(formDataS3, fileObj.invoiceNumber);
      const s3ResponseVizio = await uploadInvoiceDocOCRVizio(formDataS3, fileObj.invoiceNumber);

      await InsertOCRApiResponseLog({
        invoiceNumber: fileObj.invoiceNumber,
        isSupplierInv: true,
        apiPayload: JSON.stringify({ fileName: fileObj.name }),
        apiResponseCode: s3Response.status,
        apiResponseMessage: s3Response.statusText,
        apiResponse: JSON.stringify(s3Response.data),
        createdBy: getUser().uid,
      });
          const docViewResponse = await viewDoc(fileObj.documentLink);
              fileObj.viewLink = docViewResponse?.data?.Message;
              fileObj.documentLink = docViewResponse?.data?.Message;
            }
      
    

    // Step 2️⃣ Insert metadata into DB first
    const uploadedFileMetaData = fileList.map(file => ({
      invoiceNumber: file.invoiceNumber,
      documentName: file.name,
      documentLink: file.documentLink,
      documentType: file.documentType,
      isSupplierInv: true,
      isSentToKlearStack: 1,
      UploadBy: getUser().uid,
      supplierId: file.supplierId,
      uploadDate: new Date().toISOString().slice(0, 19).replace("T", " "),
    }));

    const insertResponse = await InsertInvoiceDocDetailsForOCR(uploadedFileMetaData);
    const InvoiceDocId = insertResponse?.data?.InvoiceDocId;
    if (!InvoiceDocId) {
      showToast("danger", "Failed to retrieve InvoiceDocId.");
      return;
    }

    const invoiceDetails = await getInvoiceDocumentDetails(InvoiceDocId);
    const invoiceDocs = Array.isArray(invoiceDetails?.data) && invoiceDetails.data.length > 0
      ? invoiceDetails.data
      : [{ InvoiceDocId }];

    // Step 3️⃣ Group files by invoice number
    const filesByInvoice = fileList.reduce((acc, file) => {
      if (!acc[file.invoiceNumber]) acc[file.invoiceNumber] = [];
      acc[file.invoiceNumber].push(file);
      return acc;
    }, {});

    // Step 4️⃣ Process each invoice separately
    for (const [invNumber, files] of Object.entries(filesByInvoice)) {
      let isFirstUpload = true;
      let savedReferenceNumber = null;

      const hasCommercial = files.some(f => f.documentType === "Commercial Invoice");
      const hasPackingList = files.some(f => f.documentType === "Packing List");

      // === 4a️⃣ Upload Commercial Invoice First ===
      if (hasCommercial) {
        for (const fileObj of files.filter(f => f.documentType === "Commercial Invoice")) {
          const mappedDocType = "Invoices";
          const formData = new FormData();
          formData.append("file", fileObj.file);
          formData.append("invoiceNumber", fileObj.setName);
          formData.append("documentType", mappedDocType);
          formData.append("set_name", fileObj.setName);
          formData.append("create_new_set", isFirstUpload ? "true" : "false");

          const response = await axios.post(
            "https://vizioapi.quloi.com/AryabhattaDev/uploadFile",
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );

          await InsertOCRApiResponseLog({
            invoiceNumber: fileObj.invoiceNumber,
            isSupplierInv: true,
            apiPayload: JSON.stringify({ fileName: fileObj.name }),
            apiResponseCode: 200,
            apiResponseMessage: response.statusText,
            apiResponse: JSON.stringify(response.data),
            createdBy: getUser().uid,
          });

          // Save reference number if first upload
          if (isFirstUpload && response.data.set_reference_number) {
            savedReferenceNumber = response.data.set_reference_number;
            for (const doc of invoiceDocs) {
              await updateinvoicedetails({
                ColName: "set_reference_number",
                Id: doc.InvoiceDocId,
                PreValue: "null",
                NewValue: savedReferenceNumber,
                CreatedBy: getUser().uid,
              });
            }
          }

          // ✅ Update SendToKlearStackDate for Commercial Invoice immediately
          const currentDateTime = new Date().toISOString().slice(0, 19).replace("T", " ");
          for (const doc of invoiceDocs) {
            await updateinvoicedetails({
              ColName: "SendToKlearStackDate",
              Id: doc.InvoiceDocId,
              PreValue: "null",
              NewValue: currentDateTime,
              CreatedBy: getUser().uid,
            });
          }

          isFirstUpload = false;
        }

        showToast("info", `Commercial Invoice uploaded for ${invNumber}`);
      }

      // === 4b️⃣ Wait for CommercialInvoiceReceived before Packing List ===
      if (hasPackingList) {
        showToast("info", `Waiting for Commercial Invoice confirmation for ${invNumber}...`);

        let confirmed = false;
        let retries = 0;
        const maxRetries = 15;
        const delayMs = 5000;

        while (!confirmed && retries < maxRetries) {
          try {
            const url = `https://vizioapi.quloi.com/AryabhattaDev/is-commercial-received/${invNumber}`;
            const resp = await axios.get(url, {
              headers: { Authorization: `Bearer ${getUser().token}` },
            });

            if (resp?.data?.CommercialInvoiceReceived === true) {
              confirmed = true;
              showToast("success", `Commercial Invoice confirmed. Uploading Packing List for ${invNumber}...`);
              break;
            } else {
              await new Promise(resolve => setTimeout(resolve, delayMs));
              retries++;
            }
          } catch (err) {
            console.error("Error checking Commercial Invoice:", err);
            break;
          }
        }

        if (!confirmed) {
          showToast("warning", `Commercial Invoice not confirmed after waiting. Skipping Packing List for ${invNumber}.`);
          continue;
        }
      }

      // === 4c️⃣ Upload Packing List (after CI confirmed) ===
      for (const fileObj of files.filter(f => f.documentType === "Packing List")) {
        const mappedDocType = "PackingList";
        const formData = new FormData();
        formData.append("file", fileObj.file);
        formData.append("invoiceNumber", fileObj.setName);
        formData.append("documentType", mappedDocType);
        formData.append("set_name", fileObj.setName);
        formData.append("create_new_set", isFirstUpload ? "true" : "false");

        if (!isFirstUpload && savedReferenceNumber) {
          formData.append("set_reference_number", savedReferenceNumber);
        }

        const response = await axios.post(
          "https://vizioapi.quloi.com/AryabhattaDev/uploadFile",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        await InsertOCRApiResponseLog({
          invoiceNumber: fileObj.invoiceNumber,
          isSupplierInv: true,
          apiPayload: JSON.stringify({ fileName: fileObj.name }),
          apiResponseCode: 200,
          apiResponseMessage: response.statusText,
          apiResponse: JSON.stringify(response.data),
          createdBy: getUser().uid,
        });

        // ✅ Update SendToKlearStackDate for Packing List (after waiting)
        const plDateTime = new Date().toISOString().slice(0, 19).replace("T", " ");
        for (const doc of invoiceDocs) {
          await updateinvoicedetails({
            ColName: "SendToKlearStackDate",
            Id: doc.InvoiceDocId,
            PreValue: "null",
            NewValue: plDateTime,
            CreatedBy: getUser().uid,
          });
        }
      }

      // === 4d️⃣ Insert OCR mapped data ===
      for (const fileObj of files) {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const monthFolder = `${year}-${month}`;

        const ocrPayload = {
          invoiceId: InvoiceDocId,
          invoiceNumber: fileObj.invoiceNumber,
          setReferenceNumber: savedReferenceNumber ?? "",
          isSupplierInv: true,
          documentTypeId: { "Commercial Invoice": 1, "Packing List": 2 }[fileObj.documentType] || 0,
          documentName: fileObj.name,
          documentLink: `OCR/${monthFolder}/${fileObj.name}`,
        };

        const ocrResponse = await axios.post(
          "https://vizioapi.quloi.com/viziostage/api/OCR/insertOCRData",
          ocrPayload
        );

        await InsertOCRApiResponseLog({
          invoiceNumber: fileObj.invoiceNumber,
          isSupplierInv: true,
          apiPayload: JSON.stringify(ocrPayload),
          apiResponseCode: ocrResponse.status,
          apiResponseMessage: ocrResponse.statusText,
          apiResponse: JSON.stringify(ocrResponse.data),
          createdBy: getUser().uid,
        });
      }

      // === 5️⃣ Update isSentToKlearStack flag ===
      for (const doc of invoiceDocs) {
        await updateinvoicedetails({
          ColName: "isSentToKlearStack",
          Id: doc.InvoiceDocId,
          PreValue: 0,
          NewValue: 1,
          CreatedBy: getUser().uid,
        });
      }

      showToast("success", `Invoice ${invNumber} fully processed.`);
    }

    setFileList([]);
    setInvoiceNumber("");
    setSelectedSupplier("");
    showToast("success", "All files uploaded and processed successfully.");
  } catch (error) {
    console.error("Upload failed:", error);
    showToast("danger", "Upload failed. Check console for details.");
  } finally {
    setLoading(false);
  }
};




  const handleRemove = (index) => {
    setFileList(fileList.filter((_, i) => i !== index));
  };

  const showToast = (variant, message) => {
    setToastMessage({ variant, message });
  };

  return (
    <div className="upload-container">
      <h1>Invoice File Upload</h1>
      <Form>
        <Row className="align-items-center mb-3 g-2">
          <Col md={3}>
            <Form.Control
              type="text"
              placeholder="Enter Invoice Number"
              value={invoiceNumber}
              onChange={(e) => setInvoiceNumber(e.target.value)}
            />
          </Col>
          <Col md={3}>
  <Select
    options={supplierOptions.map((s) => ({
      value: s.Id,
      label: s.Name,
    }))}
    value={supplierOptions.find((s) => s.Id === selectedSupplier) ? {
      value: selectedSupplier,
      label: supplierOptions.find((s) => s.Id === selectedSupplier)?.Name,
    } : null}
    onChange={(selectedOption) =>
      setSelectedSupplier(selectedOption ? selectedOption.value : "")
    }
    isClearable
    placeholder="Select Supplier"
  />
</Col>
          <Col md={3}>
            <Form.Control
              type="file"
              accept="application/pdf"
              onChange={handleFileChange}
              disabled={!invoiceNumber.trim() || !selectedSupplier}
              ref={fileInputRef}
            />
          </Col>
          <Col md={3}>
            <div className="d-flex gap-3">
              {["Commercial Invoice", "Packing List"].map((type, idx) => (
                <Form.Check
                  inline
                  key={idx}
                  type="radio"
                  label={type}
                  name="fileType"
                  value={type}
                  checked={selectedFileType === type}
                  onChange={handleFileTypeChange}
                />
              ))}
            </div>
          </Col>
        </Row>
      </Form>

      <ToastContainer className="p-3" position="top-end">
        {toastMessage && (
          <Toast
            bg={toastMessage.variant}
            onClose={() => setToastMessage(null)}
            autohide
            delay={4000}
          >
            <Toast.Body>{toastMessage.message}</Toast.Body>
          </Toast>
        )}
      </ToastContainer>

      {fileList.length > 0 && (
        <>
       <Table striped bordered hover>
  <thead>
    <tr>
      <th>#</th>
      <th>File Name</th>
      <th>Invoice Number</th>
      <th>Document Type</th>
      <th>Upload Date</th>
      <th>Preview</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {fileList.map((file, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{file.name}</td>
        <td>{file.invoiceNumber}</td>
        <td>{file.documentType}</td>
        <td>{file.date}</td>
        <td>
          <Button size="sm" onClick={() => handlePreview(file)}>
            Preview
          </Button>
        </td>
        <td>
          <Button
            variant="danger"
            size="sm"
            onClick={() => handleRemove(index)}
          >
            Remove
          </Button>
        </td>
      </tr>
    ))}
  </tbody>
</Table>

          <Button
            className="upload-btn"
            onClick={handleUpload}
            disabled={loading}
          >
            {loading ? <PulseLoader size={6} color="#fff" /> : "Upload"}
          </Button>
        </>
      )}
   <Modal show={showPreview} onHide={cancelPreview} size="lg" centered>
  <Modal.Header closeButton>
    <Modal.Title>Verify Document Before Upload</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {previewFile?.previewUrl && (
      <embed
        src={previewFile.previewUrl}
        type="application/pdf"
        width="100%"
        height="500px"
      />
    )}
  </Modal.Body>
  <Modal.Footer>
  <Button variant="secondary" onClick={cancelPreview}>Cancel</Button>
  {!previewFile?.alreadyInList && (
    <Button variant="primary" onClick={confirmPreview}>Confirm</Button>
  )}
  {previewFile?.alreadyInList && (
    <Button variant="primary" disabled>Already Added</Button>
  )}
</Modal.Footer>
</Modal>

    </div>
  );
}

export default Supplier;